import { AxiosInstance } from 'axios'

export enum SkinColor {
  WHITE = 'WHITE',
  BROWN = 'BROWN',
  BLACK = 'BLACK',
  YELLOW = 'YELLOW',
  INDIGENOUS = 'INDIGENOUS',
}

export type Patient = {
  id: number
  uuid: string
  name: string
  socialName: string | null
  birthday: string | null
  gender: 'M' | 'F' | null
  address: string | null
  number: string | null
  complement: string | null
  district: string | null
  cityId: number | null
  zipCode: string | null
  testPerson: boolean | null
  userId: number | null
  cpf: string | null
  motherName: string | null
  skinColor: SkinColor | null
  assignedSex: string | null
  currentWeightKg: string | null
  currentHeightCm: string | null
  healthPlan: string | null
  city: { id: number; name: string } | null
  mobile: string | null
  email: string | null
  age: string | null
  acceptedTerms: boolean
}

export function patientEndpoints(apiClient: AxiosInstance) {
  return {
    async getWithAttendances(id: number): Promise<Patient> {
      return apiClient.get(`get-patient-by-id-with-attendances/${id}`)
    },
    async partialUpdatePatient(data: any): Promise<void> {
      return apiClient.patch(`partial-update-patient`, data)
    },
  }
}
